import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../model/user';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'welcome-dialog',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './welcome-dialog.component.html',
  styleUrl: './welcome-dialog.component.scss',
})
export class WelcomeDialogComponent {
  @Input() active: boolean = false;
  @Input() user: User = {};
  @Output() modalClosed = new EventEmitter<boolean>();

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.closeDialog();
  }
}
